import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { AdminDashboard, TeacherDashboard } from '../components/dashboard';
import {
  useAdminDashboardStats,
  useTeacherDashboardStats,
} from '../hooks/api/useDashboard';
import { useClassroomsWithStats } from '../hooks/api/useClassrooms';
import { Spinner } from '../components/ui';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  // ``is_superuser`` is the API's name for "this caller has an admin
  // role" (super_admin / org_admin / principal -- see User.is_admin
  // server-side). The legacy ``is_staff`` flag is a Django leftover and
  // is true for ordinary teachers, so we deliberately do not consult it.
  const isAdmin = user?.is_superuser ?? false;

  const adminQuery = useAdminDashboardStats(isAdmin);
  const teacherQuery = useTeacherDashboardStats(!isAdmin);
  const { data: classrooms, isLoading: classroomsLoading } =
    useClassroomsWithStats();

  const activeQuery = isAdmin ? adminQuery : teacherQuery;
  const isLoading = activeQuery.isLoading || classroomsLoading;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Spinner size="lg" />
      </div>
    );
  }

  if (isAdmin) {
    return <AdminDashboard stats={adminQuery.data} />;
  }

  return (
    <TeacherDashboard
      stats={teacherQuery.data}
      classrooms={classrooms}
    />
  );
};

export default Dashboard;
